import React from 'react'
import { EventCardCon } from './styles'
import { AcademyEvent } from '../../../../Api'
import { PLL_IMAGES } from '../../../../Config/config'
import { Head2 } from '../../../../Components/Typography/Text.styles'
import { logEvent } from '../../../../Utils'
import { ShareButton } from '../../../../Components/Buttons/ShareButton'
import { colors } from '../../../../Components/consts'
import { Img } from '../../../../Components/Image/Img'
import { Lk } from '../../../../Components/Links/Lk'

type AcademyEventRowsProps = {
  ev: AcademyEvent
}

export const AcademyEventCard: React.FC<AcademyEventRowsProps> = ({ ev }) => {
  const cardTheme = ev.boysOrGirls === 'Girls' ? 'dark' : 'light'
  const primaryColor = ev.boysOrGirls === 'Girls' ? colors.unleashed : colors.yellow

  const log = async () => {
    logEvent('academy_training_share', {
      event_name: ev.eventName,
      date: ev.formattedEventDate,
      city: ev.city,
      state: ev.state,
      link: ev.link,
    })
    return Promise.resolve()
  }

  return (
    <EventCardCon participant={ev.boysOrGirls}>
      {ev.verifiedEvent && (
        <div className="verifiedCon">
          <Img src={PLL_IMAGES.academyVerified} alt={`${ev.eventName} image `} />
        </div>
      )}
      {ev.boysOrGirls === 'Both' && (
        <div className="bothCon">
          <p>Boys & Girls</p>
        </div>
      )}
      {ev.eventImg ? (
        <div className="imgCon">
          <Img src={ev.eventImg} alt={`${ev.eventName} image `} />
        </div>
      ) : (
        <div className="imgCon">
          <Img src={PLL_IMAGES.academyWatermark} alt={`${ev.eventName} image `} />
        </div>
      )}
      <div className="infoCon">
        <div
          className="shareCon"
          onClick={() =>
            logEvent('academy_training_share', {
              event_name: ev.eventName,
              date: ev.formattedEventDate,
              city: ev.city,
              state: ev.state,
              link: ev.link,
            })
          }
        >
          <ShareButton
            theme={cardTheme}
            circular
            background={primaryColor}
            shareLink={ev.link}
            size="lg"
            border={true}
          >
            Share
          </ShareButton>
        </div>
        <div className="upper">
          <div className="date">
            {ev.formattedEventDate}
            {ev.eventTime ? ` • ${ev.eventTime}` : ''}
          </div>
          <div className="location">{`${ev.city}, ${ev.state}`}</div>
        </div>
        <Head2>{ev.eventName}</Head2>
        <div className="athCon">
          <p>ATHLETES</p>
          {ev?.athletes.length > 0 && (
            <div className="athName">{ev.athletes.join(', ')}</div>
          )}
        </div>
      </div>
      <Lk
        classNameObj="bookingCon"
        link={ev.link}
        alt={`${ev.eventName} - ${ev.formattedEventDate} - ${ev.city}, ${ev.state}`}
        onBeforeNavigate={() => log()}
      >
        <div className="bookingCon">Register</div>
      </Lk>
    </EventCardCon>
  )
}
